// extracted by mini-css-extract-plugin
export default {"Tag_Title":"TaggedText_Tag_Title__TyM3q","Tag_Content":"TaggedText_Tag_Content__C+1oQ","IonIcon":"TaggedText_IonIcon__lrv+9"};